<template>
  <section>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar flat color="brown lighten-5">
          <!-- <v-btn color="green lighten-3" icon> -->
          <!-- <v-icon>mdi-tune</v-icon> -->
          <!-- </v-btn> -->
          <v-toolbar-title>
            <v-icon class="mr-3">mdi-cog-outline</v-icon>
            <span class="brown--text lighten-4">Settings / </span>
            Associations & Groups
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="dialog = false">
              Close
              <v-icon class="ml-2">mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row class="mx-5 my-5">
          <v-col cols="12">
            <Associations />
          </v-col>
          <!-- <v-col cols="5">
            <h3>Something comes here.</h3>
          </v-col> -->
        </v-row>
      </v-card>
    </v-dialog>
    <!-- </v-row> -->
  </section>
</template>


<script>
import Associations from "../components/utils/Associations.vue";

export default {
  components: {
    Associations,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    openAssociations() {
      this.dialog = true;
    },
  },

  mounted() {
    this.$bus.$on("settings.associations", this.openAssociations);
  },
};
</script>